import React from 'react';
import { motion } from 'framer-motion';
import { Palette, Camera, LayoutList, Rocket } from 'lucide-react';
const sections = [{
  icon: <Palette className="w-6 h-6 text-brand-green" data-id="element-181" />,
  title: 'SECCIÓN 1 — Identidad Visual Premium',
  items: ['Psicología del color para alimentos', 'Logo en Canva en 30 minutos', 'Sistema de stickers profesionales con QR', 'Tipografías que venden vs tipografías que asustan']
}, {
  icon: <Camera className="w-6 h-6 text-brand-green" data-id="element-182" />,
  title: 'SECCIÓN 2 — Catálogo Fotográfico',
  items: ['Kit de fotografía costo $0', 'Los 5 planos de venta para comida', 'Catálogo PDF interactivo para WhatsApp', '5 apps para retocar fotos en 30 segundos']
}, {
  icon: <LayoutList className="w-6 h-6 text-brand-green" data-id="element-183" />,
  title: 'SECCIÓN 3 — Ingeniería de Menú',
  items: ['Método Gancho vs Estrella', 'Rotación de menú siempre fresco', 'Calendario estacional argentino mes a mes', 'Up-selling manual por WhatsApp con guiones']
}, {
  icon: <Rocket className="w-6 h-6 text-brand-green" data-id="element-184" />,
  title: 'SECCIÓN 4 — Escala y Automatización',
  items: ['Planilla de gestión de pedidos', '10 Respuestas Rápidas de WhatsApp Business', 'Cómo conseguir tus primeros 3 puntos de venta', 'Plan de inversión con tus propias ganancias']
}];
export function MarcaGourmetDetails() {
  return <section className="py-10 px-4 bg-cream-light" data-id="element-185">
      <div className="max-w-5xl mx-auto" data-id="element-186">
        <h3 className="text-2xl md:text-3xl font-bold text-center mb-12 font-serif" data-id="element-187">
          ✅ EL KIT MARCA GOURMET INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-188">
          {sections.map((sec, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-cream-dark" data-id="element-189">
              <div className="flex items-center gap-3 mb-4" data-id="element-190">
                <div className="bg-brand-green/10 p-2 rounded-lg" data-id="element-191">
                  {sec.icon}
                </div>
                <h4 className="font-bold text-carbon text-lg" data-id="element-192">{sec.title}</h4>
              </div>
              <ul className="space-y-2" data-id="element-193">
                {sec.items.map((item, j) => <li key={j} className="flex items-start gap-2 text-sm text-carbon-lighter" data-id="element-194">
                    <span className="text-brand-green mt-0.5" data-id="element-195">•</span>
                    {item}
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}